var path = 'templates/news.html';
var html = "<md-content class=news> <h2>工事中</h2> </md-content> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/news.html
// module id = 32
// module chunks = 0